import React from "react";
import styled from "@emotion/styled";
import { Tree, TreeNode } from "react-organizational-chart";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import { treepayload } from "./hierachy";
import randomColor from "randomcolor";


const StyledNode = styled.div`
  padding: 5px 10px;
  border-radius: 8px;
  display: flex;          /* flex to arrange avatar and text horizontally */
  align-items: center;    /* vertically center avatar and text */
  justify-content:center;

  gap: 8px;               /* space between avatar and text */
`;

const Avatar = styled.div`
  height: 35px;
  width: 35px;
  border-radius: 50%;
   background-color: ${(props) => props.bg || "#6c63ff"};
  color: white;
  font-weight: bold;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Name = styled.span`
  font-size: 14px;
  font-weight: 500;
`;

const StyledTreeExample = () => 
     
    {
         const levelColors = {};

  const getColorForLevel = (level) => {
    if (!levelColors[level]) {
      levelColors[level] = randomColor(); // generate once for this level
    }
    return levelColors[level];
  };
   const    Getrecursivenode = ({nodes=[],level=1})=>{
     

    return nodes.map((node,ind)=>{
        
          const bgcolor = getColorForLevel(level);
      return  (
      <TreeNode  key={ind} label={   <StyledNode>
      <Avatar bg={bgcolor}>{node?.name?.charAt(0).toUpperCase()}</Avatar>
      <Name>{node?.name}</Name>
    </StyledNode>}>
    {node?.subordinates?.length > 0 ? (
    <Getrecursivenode nodes={node.subordinates}   level={level + 1} />
) : null}  

    </TreeNode>

    )

    }
)


    
   

   }

      

   return(
        <DashboardLayout>
        <Tree
    lineWidth={"1px"}
    lineColor={"black"}
    lineBorderRadius={"0px"}
    label={<StyledNode>
         <Avatar>{treepayload[0]?.name?.charAt(0).toUpperCase()}</Avatar>
       <Name>{treepayload[0]?.name}</Name> 
        
        </StyledNode>}


  >

    <Getrecursivenode
      nodes ={ treepayload?.[0]?.subordinates}
    />

        
  </Tree>
    </DashboardLayout>
   )

    }

export default StyledTreeExample;
